import React from 'react';
import NiceicDownloadButton from './niceic_download_button';

class NiceicPocketGuidesHeader extends React.PureComponent {
  render() {
    const {
      filteredGuides,
      handleDownload,
      handleBack,
      formSubmitted,
      downloadIcon,
      warningIcon,
      selectedCount
    } = this.props;

    if (!filteredGuides || (filteredGuides && filteredGuides.length === 0)) {
      return (
        <div className="pocket-guides__header m-fl ai-c jc-sb">
          <div>
            <h3 className="pocket-guides__header-title">Downloads</h3>
            <p className="pocket-guides__header-text">
              Please select the Pocket Guides you would like to download below
            </p>
          </div>
          <NiceicDownloadButton
            handleDownload={handleDownload}
            isDisabled={selectedCount > 0 ? false : true}
          />
        </div>
      );
    }

    if (filteredGuides && filteredGuides.length >= 1) {
      return (
        <div className="pocket-guides__header">
          {!formSubmitted ? (
            <div className="pocket-guides__header-wrapper fw-w m-fl ai-c jc-sb">
              <div className="pocket-guides__header-content">
                <h3 className="pocket-guides__header-title">
                  <img
                    src={downloadIcon}
                    alt=""
                    className="pocket-guides__icon"
                  />
                  <div>
                    <span>
                      {filteredGuides.length} Pocket{' '}
                      {filteredGuides.length === 1 ? 'Guide' : 'Guides'}{' '}
                    </span>
                    selected for download
                  </div>
                </h3>
                <p className="pocket-guides__header-text">
                  Please fill out the form below to access the downloads.
                </p>
              </div>
              <button
                className="pocket-guides__download-btn pocket-guides__download-btn--change-btn"
                onClick={handleBack}
              >
                Change Selected Files
              </button>
            </div>
          ) : (
            <div className="pocket-guides__header-wrapper fw-w m-fl ai-c jc-sb">
              <div className="pocket-guides__header-content">
                <h3 className="pocket-guides__header-title">
                  <img
                    src={downloadIcon}
                    alt=""
                    className="pocket-guides__icon"
                  />
                  Your Pocket Guides are ready to download
                </h3>
                <p className="pocket-guides__header-text">
                  Please download the files to save them to your device.
                </p>
              </div>
              <p className="pocket-guides__warning">
                <img src={warningIcon} alt="" />
                The download links will not be available after leaving this
                page.
              </p>
            </div>
          )}
        </div>
      );
    }
  }
}

export default NiceicPocketGuidesHeader;
